/* stats/reducer */
import { createReducer } from "typesafe-actions";
import { StatsActionTypes, StatsState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchError,
} from "./actions";

export const initialState: StatsState = {
  data: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>;

export default createReducer<StatsState, ActionType>(initialState)
  .handleType(StatsActionTypes.FETCH, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(StatsActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(StatsActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload,
    };
  });